import SectionManager from './sectionManager';
import Nav from './nav';
import FeatureVideoPlayer from './featureVideoPlayer';
import Schematic from "./schematic";
import {getScrollTop} from "./utilities";

let Application = function (params) {
  if (Application.prototype._singletonInstance) {
    return Application.prototype._singletonInstance;
  }
  Application.prototype._singletonInstance = this;

  // this.initialize(params);
};

Application.prototype.initialize = function (params) {
  // console.log('Application initalizing ' + params);

  // Application.tweenLength = 0.5;
  // Application.tweenStagger = "-=0.25";

  this.currentSectionIndex = 0;
  this.setCurrentSectionIndex = function(index) {
    // console.log('setting current section to ' + index);
    // console.log('this.sectionMarkers is ', this.sectionMarkers);
    this.currentSectionIndex = index;
    // TODO: calc from scrollTop and markers instead of using indexes
    let scrollTop = getScrollTop();
    let sectionIndex = 0;
    for(let i = this.sectionMarkers.length - 1; i >= 0; i--) {
      if (scrollTop > this.sectionMarkers[i].start) {
        sectionIndex = i;
        break;
      }
    }
    this.currentSectionIndex = sectionIndex;
    // console.log('Calculated current section is ' + sectionIndex);
    // let index = 0;
    // while (scrollTop < this.sectionMarkers[index].start) {
    //   index++;
    // }
  }

  this.sectionMarkers = [];
  this.setSectionMarkers = function(index, start, end) {
    // console.log('setting section markers ' + index + ": " + start + ', ' + end);
    this.sectionMarkers[index] = {start: start, end: end};
    // console.log('section markers are ', this.sectionMarkers);
  }

  this.firstContentPositions = [];
  // set the intro position by default, never changes or refreshes
  this.firstContentPositions[0] = 0;
  this.setFirstContentPosition = function(index, position) {
    // console.log('setting first content marker ' + index + ": " + position);
    this.firstContentPositions[index] = position;
    // console.log('section first content ', this.firstContentPositions);
  }

  /**
   *
   */
  let self = this;
  this.schematic = new Schematic();
  this.sectionManager = new SectionManager({});
  this.featureVideoPlayer = new FeatureVideoPlayer();
  this.nav = new Nav({});




  // this.test = function () {
    // this.intro.open();
    // this.currentState = "questions";
    // document.getElementById('content').style.display = 'block';
    // this.questions.open();
  // };

};

export default Application;

